import { registerSW } from 'virtual:pwa-register'

registerSW({
  onRegisteredSW: async (swUrl, r) => {
    setInterval(async () => {
      // if users have too many go tabs open, having each tab check
      // might overwhelm their network and cause network issues
      if (document.visibilityState === 'hidden') return
      // if the worker is already installing, supposedly, r.update will fail
      if (r?.installing) return
      // if the user is offline, update will fail
      if (!navigator.onLine) return

      // checks for new service worker every 2 minutes, provided other conditions are met,
      //
      await r?.update()
    }, 60_000)
  },
  onRegisterError(error) {
    // eslint-disable-next-line no-console
    console.error(error)
  },
})
